<template>
  <b-form-group
    :label="label"
    :label-for="name"
    :description="helptext"
  >
    <c-switch
      class="mx-1"
      variant="success"
      :value="1"
      :pill="true"
      :uncheckedValue="0"
      @change="change()"
      v-model="state"
      :id="name"
      @blur.native="handler.form[name].$touch"
    />
    <div v-if="formHandle.$error">
      <div class="invalid-feedback d-block" v-for="error in errors" :key="error">{{ errorMessage[error] }}</div>
    </div>
  </b-form-group>
</template>

<script>
import cSwitch from '../Switch'

export default {
  data: () => {
    return {
      state: ''
    }
  },
  components: {
    cSwitch
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    model: {
      type: String | Number
    },
    name: {
      type: String,
      default: ''
    },
    handler: {
      type: Array | Object
    },
    formData: {
      type: Array | Object
    },
    disabled: {
      type: Boolean,
      default: false
    },
    helptext: {
      type: String,
      default: ''
    }
  },
  model: {
    prop: 'model',
    event: 'updateModel'
  },
  created () {
    this.state = this.model
  },
  methods: {
    change () {
      this.$emit('updateModel', this.state)
    }
  },
  watch: {
    'model': function () {
      this.state = this.model
    }
  },
  computed: {
    errors: function () {
      return Object.getOwnPropertyNames(this.formHandle).filter(x => {
        return this.formHandle[x] === false && x[0] !== '$'
      })
    },
    formHandle: function () {
      let data = this.name.split('.').reduce((acc, curr) => {
        return acc[curr]
      }, this.handler.form)
      return data
    },
    errorMessage: function () {
      let data = this.name.split('.').reduce((acc, curr) => {
        return acc[curr]
      }, this.formData.errorMessages)
      return data
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/custom/PSwitch.vue